export const COLOR_GREY = ['#0f0f0f', '#2d2e2f'];

export const COLOR_BLUE = [
	'#152a55',
	'#0b263c',
	'#083672',
	'#0a3a59',
	'#262f89',
];

export const COLOR_GREEN = ['#124632', '#1B8449'];

export const COLOR_RED = ['#501131', '#cc0816', '#b82832', '#950039'];
